import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Facebook({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M22 12.0622C22 6.50777 17.5201 2 12 2C6.47992 2 2 6.50777 2 12.0622C2 17.0881 5.65602 21.2539 10.4449 22V14.9637H7.89083V12.0622H10.4449V9.84456C10.4449 7.32643 11.9279 5.92746 14.2142 5.92746C15.3059 5.92746 16.4387 6.13471 16.4387 6.13471V8.59067H15.1823C13.9361 8.59067 13.5448 9.37824 13.5448 10.1658V12.0518H16.3254L15.8826 14.9534H13.5448V21.9896C18.344 21.2539 22 17.0881 22 12.0622Z" fill="currentColor" /></Svg>;
}
export default Facebook;